export const MAX_CHARACTERS = 2000;
export const AUTOSAVE_DEBOUNCE_MS = 2000;
export const DRAWER_EXPANDED_HEIGHT = "80vh";

export const INDICATOR_COLORS = {
  error: "error.main",
  unsaved: "warning.main",
  saved: "success.main",
} as const;
